import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useIsSmallScreen } from '../../../hooks/useIsSmallScreen';
import '../ManagementPage.css';

interface SubColumnProps {
    /** Heading text, shown with the count: "Felanmälningar (9)". */
    title: string;
    count: number;
    emptyMessage: string;
    children: React.ReactNode;
    /** Optional footer at the bottom of the list (e.g. a snoozed section). */
    footer?: React.ReactNode;
}

/**
 * One subcolumn of a wide board column ("Att hantera", "Delegerade/planerade").
 * Side by side on desktop; on phones the subcolumns stack, so the header
 * becomes a toggle that collapses the list.
 */
const SubColumn: React.FC<SubColumnProps> = ({ title, count, emptyMessage, children, footer }) => {
    const isSmallScreen = useIsSmallScreen();
    const [open, setOpen] = useState(true);
    const heading = `${title} (${count})`;

    return (
        <div className="column-subcolumn">
            {isSmallScreen ? (
                <button
                    type="button"
                    className="column-subcolumn-header column-subcolumn-toggle"
                    aria-expanded={open}
                    onClick={() => setOpen(prev => !prev)}
                >
                    <span>{heading}</span>
                    <ChevronDown size={20} className="column-subcolumn-chevron" aria-hidden="true" />
                </button>
            ) : (
                <div className="column-subcolumn-header">{heading}</div>
            )}
            {(open || !isSmallScreen) && (
                <div className="column-subcolumn-list">
                    {count === 0 ? (
                        <div className="management-column__empty">{emptyMessage}</div>
                    ) : children}
                    {footer}
                </div>
            )}
        </div>
    );
};

export default SubColumn;
